import React from 'react';
import style from './style.module.scss';
import { Link, Typography } from '@material-ui/core';
import { IBookingLink } from 'shared-types/index';


/** Render booking links */
export const BookingLinks: React.FC<IBookingLink[]> = (props) => {

  const bookingLinks = Object.values(props);

  // Do not proceed, when no links are provided
  const hasSpecifiedLink = bookingLinks.some(link => !!(link.linkName || link.linkURL));
  if (!hasSpecifiedLink) return null;

  return(
    <>
      <p className={style.summaryLabel}>Links</p>
      {
        bookingLinks.map((item, index) => {
          return (
            <Typography key={index}>
              <Link href={item.linkURL} target="_blank" rel="noopener">
                {item.linkName || item.linkURL}
              </Link>
            </Typography>
          )
        })
      }
      <hr className={style.summaryHorizontalLine} />
    </>
  )
}